import { SURVEY } from 'redux/constants/action-types';
import surveyClient from './surveyClient';

export function fetchAlertCount() {
  return async function (dispatch) {
    try {
      const response = await surveyClient.get('/alerts/count');
      dispatch({ type: SURVEY.GET_ALERT_COUNT, payload: response.data?.count ?? 0 });
      return { denied: false };
    } catch (error) {
      // The badge simply won't update — still non-critical. But 401 (session no
      // longer authenticated) and 403 (no Survey.Analytics claim for this client)
      // cannot clear on retry, so report them and let the caller stop polling.
      // Anything else is transient and worth retrying on the next tick.
      const status = error?.response?.status;
      return { denied: status === 401 || status === 403 };
    }
  };
}

export function fetchAlerts(filters = {}) {
  return async function (dispatch) {
    try {
      const response = await surveyClient.get('/alerts', { params: filters });
      dispatch({ type: SURVEY.GET_ALERTS, payload: response.data });
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function fetchAlertDetail(alertId) {
  return async function (dispatch) {
    try {
      const response = await surveyClient.get(`/alerts/${alertId}`);
      dispatch({ type: SURVEY.GET_ALERT_DETAIL, payload: response.data });
      return response.data;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function resolveAlertAction(alertId, request = {}) {
  return async function () {
    try {
      await surveyClient.patch(`/alerts/${alertId}/resolve`, request);
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function updateAlertAction(alertId, request) {
  return async function () {
    try {
      await surveyClient.patch(`/alerts/${alertId}`, request);
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

/**
 * The From / From Name / Reply-To values this client may send as — the same ESP config
 * lists the Send Email wizard reads, so a survey send is restricted to addresses already
 * permitted for the client's authenticated sending domains.
 */
export function getSenderOptionsAction() {
  return async function () {
    try {
      const { data } = await surveyClient.get('/alerts/sender-options');
      return data;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function sendAlertEmailAction(alertId, request) {
  return async function () {
    try {
      const { data } = await surveyClient.post(`/alerts/${alertId}/send-email`, request);
      return data;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}
